import { authApi } from "./authApi";
import { moviesApi } from './moviesApi';
import { letestApi } from './letesmoviesApi'

export const API = {
    ...authApi,
    ...moviesApi,
    ...letestApi
};
